import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import emailService from "../services/email.service";

import { useFormik } from "formik";
import * as Yup from "yup";

import {
    clearMessage,
    registerAsync,
    selectMessage,
} from "../features/auth/authSlice";

const Register = () => {
    const form = useRef();
    const checkBtn = useRef();

    const [successful, setSuccessful] = useState(false);

    const message = useSelector(selectMessage);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(clearMessage());
    }, []);

    const validationSchema = Yup.object().shape({
        familyname: Yup.string()
            .required("Familyname is required")
            .min(1, "Familyname must be at least 1 characters")
            .max(20, "Familyname must not exceed 20 characters"),
        username: Yup.string()
            .required("Username is required")
            .min(1, "Username must be at least 1 characters")
            .max(20, "Username must not exceed 20 characters"),
        email: Yup.string()
            .required("Email is required")
            .email("Email is invalid"),
        password: Yup.string()
            .required("Password is required")
            .min(6, "Password must be at least 6 characters")
            .max(40, "Password must not exceed 40 characters"),
        roles: Yup.array(),
    });

    const formik = useFormik({
        initialValues: {
            familyname: "",
            username: "",
            email: "",
            password: "",
            roles: ["admin", "user"],
        },
        validationSchema,
        // validateOnChange: false,
        // validateOnBlur: false,
        onSubmit: (user) => {
            dispatch(registerAsync(user))
                .then((response) => {
                    if (response.meta.requestStatus === "rejected") {
                        setSuccessful(false);
                    } else {
                        emailService
                            .greetUser(
                                user.username,
                                user.email,
                                user.familyname
                            )
                            .then((response) => {
                                console.log(response.data);
                            })
                            .catch((e) => {
                                console.log(e);
                            });
                        setSuccessful(true);
                    }
                })
                .catch(() => {
                    setSuccessful(false);
                });
        },
    });

    const [pswType, setPswType] = useState("password");

    const toggleShowPsw = () => {
        if (pswType === "password") {
            setPswType("text");
        } else {
            setPswType("password");
        }
    };

    return (
        <div className="col-md-12 register-wrap">
            <div className="card card-container">
                <img
                    src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
                    alt="profile-img"
                    className="profile-img-card"
                />

                <form onSubmit={formik.handleSubmit} ref={form}>
                    {!successful && (
                        <div>
                            <div className="form-group">
                                <label htmlFor="familyname"> Familyname </label>
                                <input
                                    name="familyname"
                                    type="text"
                                    className={
                                        "form-control" +
                                        (formik.errors.familyname &&
                                        formik.touched.familyname
                                            ? " is-invalid"
                                            : "")
                                    }
                                    onChange={formik.handleChange}
                                    value={formik.values.familyname}
                                />
                                <div className="invalid-feedback">
                                    {formik.errors.familyname &&
                                    formik.touched.familyname
                                        ? formik.errors.familyname
                                        : null}
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="username"> Username </label>
                                <input
                                    name="username"
                                    type="text"
                                    className={
                                        "form-control" +
                                        (formik.errors.username &&
                                        formik.touched.username
                                            ? " is-invalid"
                                            : "")
                                    }
                                    onChange={formik.handleChange}
                                    value={formik.values.username}
                                />
                                <div className="invalid-feedback">
                                    {formik.errors.username &&
                                    formik.touched.username
                                        ? formik.errors.username
                                        : null}
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="email"> Email </label>
                                <input
                                    name="email"
                                    type="email"
                                    className={
                                        "form-control" +
                                        (formik.errors.email &&
                                        formik.touched.email
                                            ? " is-invalid"
                                            : "")
                                    }
                                    onChange={formik.handleChange}
                                    value={formik.values.email}
                                />
                                <div className="invalid-feedback">
                                    {formik.errors.email && formik.touched.email
                                        ? formik.errors.email
                                        : null}
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="password"> Password </label>
                                <div className="input-group">
                                    <input
                                        name="password"
                                        type={pswType}
                                        className={
                                            "form-control" +
                                            (formik.errors.password &&
                                            formik.touched.password
                                                ? " is-invalid"
                                                : "")
                                        }
                                        onChange={formik.handleChange}
                                        value={formik.values.password}
                                        autoComplete={"new-password"}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary"
                                        onClick={toggleShowPsw}
                                        style={{ borderRadius: "0 6px 6px 0" }}
                                    >
                                        {pswType === "password" ? (
                                            <i class="bi bi-eye" />
                                        ) : (
                                            <i class="bi bi-eye-slash" />
                                        )}
                                    </button>
                                    <div className="invalid-feedback">
                                        {formik.errors.password &&
                                        formik.touched.password
                                            ? formik.errors.password
                                            : null}
                                    </div>
                                </div>
                            </div>

                            <hr></hr>

                            <div className="form-group">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                >
                                    Register
                                </button>{" "}
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary float-right"
                                    onClick={formik.handleReset}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                    )}

                    {message && (
                        <div className="form-group">
                            <div
                                className={
                                    successful
                                        ? "alert alert-success"
                                        : "alert alert-danger"
                                }
                                role="alert"
                            >
                                {message}
                            </div>
                        </div>
                    )}
                    <button style={{ display: "none" }} ref={checkBtn}></button>
                </form>
            </div>
        </div>
    );
};

export default Register;
